import {createContext, useEffect, useState} from "react";
import {WIRES_TEMPLATES_SENDER_BANKER_BIC_DEFAULT} from "../../../../service/UrlConstant";

export const TEMPLATE_PANEL_HOME_PAGE = "template-home";
export const TEMPLATE_PANEL_SEARCH_PAGE = "template-search";
export const EDIT_ACTION = "Update"

export const Context = createContext({});


const initWireTemplateFilterState = {
    status:'PEND',
    startDate: '',
    endDate: ''
}

const initWireTemplateResultsDisplay = {
    templateSearch:{},
    resData:[]
}

const initWireTemplatePanelPageState = {
    currentPage : TEMPLATE_PANEL_HOME_PAGE,
}

const initTemplateActionState = {
    action : "",
    title: ""
}

const wireTemplateStatusList = [
    {label: 'PEND', value:'PEND'},
    {label: 'APPROVE', value:'APPROVE'},
    {label: 'REJECT', value:'REJECT'},
    {label: 'DELETE', value:'DELETE'},
]

const initAddWireTemplateState = {
    id:'',
    idTemplate:'',
    managerId:'',
    managerName:'',
    accountId:'',
    accountName:'',
    legalEntity:'',
    accountCode:'',
    templateName :'',
    settlementCurrency:'',
    purposeCode:'',
    chargesBearer:'OUR',

    newPageStep: '1',

    creditorAgentBIC:'',
    creditorAgentClearingSystemCode: '',
    creditorAgentClearingSystemID: '',
    creditorAgentAccountIBAN: '',
    creditorAgentName: '',
    creditorAgentDepartment: '',
    creditorAgentSubDepartment: '',
    creditorAgentStreetName: '',
    creditorAgentBuildingNumber: '',
    creditorAgentBuildingName: '',
    creditorAgentFloor: '',
    creditorAgentPostBox: '',
    creditorAgentRoom: '',
    creditorAgentPostCode: '',
    creditorAgentTownName: '',
    creditorAgentTownLocationName: '',
    creditorAgentDistrictName: '',
    creditorAgentProvince: '',
    creditorAgentCountry: '',

    creditorBIC: '',
    creditorAccountIBAN: '',
    creditorName: '',
    creditorDepartment: '',
    creditorSubDepartment: '',
    creditorStreetName: '',
    creditorBuildingNumber: '',
    creditorBuildingName: '',
    creditorFloor: '',
    creditorPostBox: '',
    creditorRoom: '',
    creditorPostCode: '',
    creditorTownName: '',
    creditorTownLocationName: '',
    creditorDistrictName: '',
    creditorProvince: '',
    creditorCountry: '',

    debtorName: '',
    debtorBIC: '',
    debtorDepartment: '',
    debtorSubDepartment: '',
    debtorStreetName: '',
    debtorBuildingNumber: '',
    debtorBuildingName: '',
    debtorFloor: '',
    debtorPostBox: '',
    debtorRoom: '',
    debtorPostCode: '',
    debtorTownName: '',
    debtorTownLocationName: '',
    debtorDistrictName: '',
    debtorProvince: '',
    debtorCountry: '',

    intermediaryAgentBIC:'',
    intermediaryAgentClearingSystemCode:'',
    intermediaryAgentClearingSystemID:'',
    intermediaryAgentAccountIBAN:'',
    intermediaryAgentName:'',
    intermediaryAgentDepartment:'',
    intermediaryAgentSubDepartment:'',
    intermediaryAgentStreetName:'',
    intermediaryAgentBuildingNumber:'',
    intermediaryAgentBuildingName:'',
    intermediaryAgentFloor:'',
    intermediaryAgentPostBox:'',
    intermediaryAgentRoom:'',
    intermediaryAgentPostCode:'',
    intermediaryAgentTownName:'',
    intermediaryAgentTownLocationName:'',
    intermediaryAgentDistrictName:'',
    intermediaryAgentProvince:'',
    intermediaryAgentCountry:'',

    senderBIC: WIRES_TEMPLATES_SENDER_BANKER_BIC_DEFAULT,
    remittanceInformation:'',
    indStatus: 'PEND',
    instructions:'',
    isValidApprover:false,
    isValidRejecter: false,
    resData:[],
}

const ADD_WIRE_TEMPLATE_STATE_STORAGE_KEY = 'wireTemplateAddState';
const validWireTemplateSteps = ['1', '2', '3', '4', '5', '6', '7'];

const getInitialAddWireTemplateState = () => {
    if (typeof window === 'undefined') {
        return initAddWireTemplateState;
    }

    try {
        const savedAddWireTemplateState = window.sessionStorage.getItem(ADD_WIRE_TEMPLATE_STATE_STORAGE_KEY);

        if (!savedAddWireTemplateState) {
            return initAddWireTemplateState;
        }

        const parsedAddWireTemplateState = JSON.parse(savedAddWireTemplateState);
        const newPageStep = parsedAddWireTemplateState?.newPageStep?.toString();

        return {
            ...initAddWireTemplateState,
            ...parsedAddWireTemplateState,
            newPageStep: validWireTemplateSteps.includes(newPageStep) ? newPageStep : initAddWireTemplateState.newPageStep
        };
    } catch (err) {
        console.log('Error on reading wire template add state from session storage: ', err);
        return initAddWireTemplateState;
    }
}


export const Provider = props => {

    const {children} = props;
    const [wireTemplatePanelFilterState, setWireTemplatePanelFilterState] = useState(JSON.parse(JSON.stringify(initWireTemplateFilterState)));
    const [wireTemplateResultsDisplayState, setWireTemplateResultsDisplayState] = useState(JSON.parse(JSON.stringify(initWireTemplateResultsDisplay)));
    const [wireTemplatePanelPageState, setWireTemplatePanelPageState] = useState(JSON.parse(JSON.stringify(initWireTemplatePanelPageState)));
    const [wireTemplateActionState, setWireTemplateActionState] = useState(JSON.parse(JSON.stringify(initTemplateActionState)));
    const [addWireTemplateState, setAddWireTemplateState] = useState(getInitialAddWireTemplateState);
    const [showGridToolbar, setShowGridToolbar] = useState(true);
    const [viewWireTemplateApproveFunction, setViewWireTemplateApproveFunction] = useState(null);
    const [viewWireTemplateRejectFunction, setViewWireTemplateRejectFunction] = useState(null);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        try {
            window.sessionStorage.setItem(ADD_WIRE_TEMPLATE_STATE_STORAGE_KEY, JSON.stringify(addWireTemplateState));
        } catch (err) {
            console.log('Error on saving wire template add state to session storage: ', err);
        }
    }, [addWireTemplateState])

    const clearWireTemplatePanelDisplayState = () => {
        const clearWireTemplatePanelFilterState = JSON.parse(JSON.stringify(initWireTemplateFilterState));
        setWireTemplatePanelFilterState(clearWireTemplatePanelFilterState);

        const clearWireTemplatesResultsDisplayState = JSON.parse(JSON.stringify(initWireTemplateResultsDisplay));
        setWireTemplateResultsDisplayState(clearWireTemplatesResultsDisplayState);

        const clearWireTemplatePanelPageState = JSON.parse(JSON.stringify(initWireTemplatePanelPageState));
        setWireTemplatePanelPageState(clearWireTemplatePanelPageState);
    }

    const clearAddNewWireTemplateState = () => {
        const clearAddNewWireTemplate = JSON.parse(JSON.stringify(initAddWireTemplateState));
        setAddWireTemplateState(clearAddNewWireTemplate);

        const clearWireTemplateActionState = JSON.parse(JSON.stringify(initTemplateActionState));
        setWireTemplateActionState(clearWireTemplateActionState);
    }

    const displayWireTemplateActionState = (actionState) => {
        const templateActionState = JSON.parse(JSON.stringify(wireTemplateActionState));
        templateActionState.action = actionState
        setWireTemplateActionState(templateActionState);
    }

    const displayWireTemplatePanelPage = (WireTemplatePanelPage) => {
        let wireTemplatePanelPageStateToShow =JSON.parse(JSON.stringify(wireTemplatePanelPageState));
        wireTemplatePanelPageStateToShow.currentPage = WireTemplatePanelPage;
        setWireTemplatePanelPageState(wireTemplatePanelPageStateToShow);
    }


    // main page
    const copyDateToAddWireTemplateState1 = (data, dataState) => {
        dataState['id']=data.id
        dataState['idTemplate']=data.idTemplate
        dataState['managerId']=data.idManager
        dataState['accountId']=data.idAccount
        dataState['templateName']=data.templateName
        dataState['settlementCurrency']=data.settlementCurrency
        dataState['purposeCode']=data.purposeCode
        dataState['senderBIC']=data.senderBIC
        dataState['remittanceInformation']=data.remittanceInformation
        dataState['isValidApprover'] = data.isValidApprover
        dataState['isValidRejecter'] = data.isValidRejecter

    }

    // creditor agent page
    const copyDateToAddWireTemplateState2 = (data,dataState) => {
        dataState['creditorAgentBIC']=data.creditorAgentBIC
        dataState['creditorAgentClearingSystemCode']=data.creditorAgentClearingSystemCode
        dataState['creditorAgentClearingSystemID']=data.creditorAgentClearingSystemID
        dataState['creditorAgentAccountIBAN']=data.creditorAgentAccountIBAN
        dataState['creditorAgentName']=data.creditorAgentName
        dataState['creditorAgentDepartment']=data.creditorAgentDepartment
        dataState['creditorAgentSubDepartment']=data.creditorAgentSubDepartment
        dataState['creditorAgentStreetName']=data.creditorAgentStreetName
        dataState['creditorAgentBuildingNumber']=data.creditorAgentBuildingNumber
        dataState['creditorAgentBuildingName']=data.creditorAgentBuildingName
        dataState['creditorAgentFloor']=data.creditorAgentFloor
        dataState['creditorAgentPostBox']=data.creditorAgentPostBox
        dataState['creditorAgentRoom']=data.creditorAgentRoom
        dataState['creditorAgentPostCode']=data.creditorAgentPostCode
        dataState['creditorAgentTownName']=data.creditorAgentTownName
        dataState['creditorAgentTownLocationName']=data.creditorAgentTownLocationName
        dataState['creditorAgentDistrictName']=data.creditorAgentDistrictName
        dataState['creditorAgentProvince']=data.creditorAgentProvince
        dataState['creditorAgentCountry']=data.creditorAgentCountry
    }

    // creditor  page
    const copyDateToAddWireTemplateState3 = (data,dataState) => {
        dataState['creditorBIC']=data.creditorBIC
        dataState['creditorAccountIBAN']=data.creditorAccountIBAN
        dataState['creditorName']=data.creditorName
        dataState['creditorDepartment']=data.creditorDepartment
        dataState['creditorSubDepartment']=data.creditorSubDepartment
        dataState['creditorStreetName']=data.creditorStreetName
        dataState['creditorBuildingNumber']=data.creditorBuildingNumber
        dataState['creditorBuildingName']=data.creditorBuildingName
        dataState['creditorFloor']=data.creditorFloor
        dataState['creditorPostBox']=data.creditorPostBox
        dataState['creditorRoom']=data.creditorRoom
        dataState['creditorPostCode']=data.creditorPostCode
        dataState['creditorTownName']=data.creditorTownName
        dataState['creditorTownLocationName']=data.creditorTownLocationName
        dataState['creditorDistrictName']=data.creditorDistrictName
        dataState['creditorProvince']=data.creditorProvince
        dataState['creditorCountry']=data.creditorCountry
    }

    // debtor   page
    const copyDateToAddWireTemplateState4 = (data,dataState) => {
        dataState['debtorName']=data.debtorName
        dataState['debtorBIC']=data.debtorBIC
        dataState['debtorDepartment']=data.debtorDepartment
        dataState['debtorSubDepartment']=data.debtorSubDepartment
        dataState['debtorStreetName']=data.debtorStreetName
        dataState['debtorBuildingNumber']=data.debtorBuildingNumber
        dataState['debtorBuildingName']=data.debtorBuildingName
        dataState['debtorFloor']=data.debtorFloor
        dataState['debtorPostBox']=data.debtorPostBox
        dataState['debtorRoom']=data.debtorRoom
        dataState['debtorPostCode']=data.debtorPostCode
        dataState['debtorTownName']=data.debtorTownName
        dataState['debtorTownLocationName']=data.debtorTownLocationName
        dataState['debtorDistrictName']=data.debtorDistrictName
        dataState['debtorProvince']=data.debtorProvince
        dataState['debtorCountry']=data.debtorCountry
    }

    // intermediary agent page
    const copyDateToAddWireTemplateState5 = (data,dataState) => {
        dataState['intermediaryAgentBIC']=data.intermediaryAgentBIC
        dataState['intermediaryAgentClearingSystemCode']=data.intermediaryAgentClearingSystemCode
        dataState['intermediaryAgentClearingSystemID']=data.intermediaryAgentClearingSystemID
        dataState['intermediaryAgentAccountIBAN']=data.intermediaryAgentAccountIBAN
        dataState['intermediaryAgentName']=data.intermediaryAgentName
        dataState['intermediaryAgentDepartment']=data.intermediaryAgentDepartment
        dataState['intermediaryAgentSubDepartment']=data.intermediaryAgentSubDepartment
        dataState['intermediaryAgentStreetName']=data.intermediaryAgentStreetName
        dataState['intermediaryAgentBuildingNumber']=data.intermediaryAgentBuildingNumber
        dataState['intermediaryAgentBuildingName']=data.intermediaryAgentBuildingName
        dataState['intermediaryAgentFloor']=data.intermediaryAgentFloor
        dataState['intermediaryAgentPostBox']=data.intermediaryAgentPostBox
        dataState['intermediaryAgentRoom']=data.intermediaryAgentRoom
        dataState['intermediaryAgentPostCode']=data.intermediaryAgentPostCode
        dataState['intermediaryAgentTownName']=data.intermediaryAgentTownName
        dataState['intermediaryAgentTownLocationName']=data.intermediaryAgentTownLocationName
        dataState['intermediaryAgentDistrictName']=data.intermediaryAgentDistrictName
        dataState['intermediaryAgentProvince']=data.intermediaryAgentProvince
        dataState['intermediaryAgentCountry']=data.intermediaryAgentCountry
    }

    const WireTemplatesContext = {
        wireTemplatePanelFilterState,
        setWireTemplatePanelFilterState,
        wireTemplateResultsDisplayState,
        setWireTemplateResultsDisplayState,
        wireTemplatePanelPageState,
        setWireTemplatePanelPageState,
        showGridToolbar,
        setShowGridToolbar,
        addWireTemplateState,
        setAddWireTemplateState,
        wireTemplateActionState,
        displayWireTemplatePanelPage,
        clearWireTemplatePanelDisplayState,
        clearAddNewWireTemplateState,
        displayWireTemplateActionState,
        wireTemplateStatusList,
        copyDateToAddWireTemplateState1,
        copyDateToAddWireTemplateState2,
        copyDateToAddWireTemplateState3,
        copyDateToAddWireTemplateState4,
        copyDateToAddWireTemplateState5,
        viewWireTemplateApproveFunction,
        setViewWireTemplateApproveFunction,
        viewWireTemplateRejectFunction,
        setViewWireTemplateRejectFunction,
        initAddWireTemplateState,
        TEMPLATE_PANEL_HOME_PAGE,
        TEMPLATE_PANEL_SEARCH_PAGE,
        EDIT_ACTION
    }

    return <Context.Provider value={WireTemplatesContext}>{children}</Context.Provider>

};

export const {Consumer} = Context;
